import {
  FETCH_LOBBY_SUCCESS,
  FETCH_LOBBY_FAIL,
  //
  DESTROY_APP,
  DESTROY_APP_SUCCESS,
  RENDER_APP,
  RESET_STORE,
  SET_IS_RENDERED,
  SET_IS_LOADING,
  SET_IS_CONFIGURATION_LOADED,
  SET_USE_DEBUG_MODE,
  SET_LOCAL_GAME_LAUNCH_MODE,
  SET_IS_THEME_APPLIED,
  LOCALIZATION_INITIALIZED,
} from '../../constants/initialization';
import NetworkError from '../../../utils/NetworkError';
import { actionCreator } from '../../helpers';

/**
 * global service action types
 */
// start loading all service required params
export const renderApp = actionCreator(RENDER_APP);
export const destroyApp = actionCreator(DESTROY_APP);
export const destroyAppSuccess = actionCreator(DESTROY_APP_SUCCESS);
export const resetStore = actionCreator(RESET_STORE);

// main loading indicator
export const setIsLoading = actionCreator(SET_IS_LOADING);

export const setIsConfigurationLoaded = (payload) => ({
  type: SET_IS_CONFIGURATION_LOADED,
  payload,
});

// toggle app mounting to DOM
export const setIsRendered = actionCreator(SET_IS_RENDERED);

export const setIsThemeApplied = actionCreator(SET_IS_THEME_APPLIED);
/**
 * Request data from backend
 */

// lobby data
export const fetchLobbySuccess = actionCreator(FETCH_LOBBY_SUCCESS);
export const fetchLobbyFail = (payload) => ({
  type: FETCH_LOBBY_FAIL,
  payload,
  error: true,
});
export const fetchLobbyFailByTimeout = () => {
  const payload = new NetworkError(503);

  return fetchLobbyFail(payload);
};

/**
 * Action creator for debug mode. Used to show additional entities which have property "status" as "Debug"
 * Redux Devtools can show "Custom actions", which are based on actions creators, which should be function declaration.
 * Do not rewrite it to arrow function, because Redux Devtools would be broken, due to failed parsing of this action creator.
 * @see https://github.com/zalmoxisus/redux-devtools-extension/commit/477e69d8649dfcdc9bf84dd45605dab7d9775c03
 * @param {boolean} payload - enable or disallow debug mode
 * @returns {{payload: *, type: string}}
 */
export function useDebugMode(payload) {
  return { type: SET_USE_DEBUG_MODE, payload };
}

/**
 * Action creator for local game launch mode. Used to enable local launch for games, which are bundled with iOS application.
 * Redux Devtools can show "Custom actions", which are based on actions creators, which should be function declaration.
 * Do not rewrite it to arrow function, because Redux Devtools would be broken, due to failed parsing of this action creator.
 * @see https://github.com/zalmoxisus/redux-devtools-extension/commit/477e69d8649dfcdc9bf84dd45605dab7d9775c03
 * @param {boolean} payload - enable or disallow debug mode
 * @returns {{payload: *, type: string}}
 */
export function setLocalGameLaunchMode(payload) {
  return { type: SET_LOCAL_GAME_LAUNCH_MODE, payload };
}

export const setLocalizationInitialized = (payload) => ({
  type: LOCALIZATION_INITIALIZED,
  payload,
});
